import {Roles} from "../../../../shared/Configs/DatabaseConsts";
import {t} from "i18next";
import { store } from "../../../../shared/redux/store";
import {AGGREGATOR_TYPE, LEAD_TYPE, STAFF_TYPE, USER_TYPE} from "../../../../shared/services/ConstHelper";
import {ROLES_FOR_VISIBILITY_SETTING} from "./TasksConsts";

export const getUpdatedDataWithTaskType = ({data, option, record, valueKey, labelKey, colorKey}) => {
    const recordIndex = data.findIndex(tuple => tuple.id === record.id);
    let temp = [...data];
    temp[recordIndex].task_type = {[valueKey]: option.id, [labelKey]: option.label, [colorKey]: option.task_type_color}
    return temp;
}

export const getAttribution = (task) => {
    if(task.is_personal) return 'personalTask'
    else if(task.target_user) {
        switch(task.target_user.role.role) {
            case Roles.AGGREGATOR:
                return 'aggregatorTask'
            case Roles.REGULAR:
                return 'clientTask'
            case Roles.LEAD:
                return 'leadTask'
            default:
                return 'staffTask'
        }
    } else {
        return 'generalTask'
    }
}

export const getTaskType = (type) => {
    switch (type) {
        case "Charge Customer":
            return t('Charge Customer')
        case  "Membership Renew":
            return t('Membership Renew')
        case "Sales Call":
            return t('Sales Call')
        case "Business Management":
            return t("Business Management")
        case "Monitor Absence":
            return t('Monitor Absence')
        case "exisitingClientWasAdded":
            return t('exisitingClientWasAdded')
        case "exisitingPhoneWasAdded":
            return t('exisitingPhoneWasAdded')
        default:
            return type
    }
}

export const showTaskNotification = (task) => {
    const notificationSettings = store.getState().box.box.settings?.task_notifications;
    if (!notificationSettings) return false;
    const isPersonal = task.is_personal && notificationSettings.personal_tasks;
    const isUser = task.target_user && notificationSettings.users_tasks;
    const isGeneral = !task.is_personal && !task.target_user && notificationSettings.general_tasks;
    return isPersonal || isUser || isGeneral;
}

export const getTypeByRole = (role) => {
    switch(role) {
        case Roles.AGGREGATOR:
            return AGGREGATOR_TYPE
        case Roles.REGULAR:
            return USER_TYPE
        case Roles.LEAD:
            return LEAD_TYPE
        case undefined:
            return null
        default:
            return STAFF_TYPE
    }

}

export const getHighestRole = () => {
    const roles = store.getState().user.user?.roles
    if(roles.find(role => role === Roles.BOXADMIN)) {
        return Roles.BOXADMIN
    }
    return roles.reduce((best, r) => {
        const rank = ROLES_FOR_VISIBILITY_SETTING.indexOf(r);
        if (rank === -1) return best;
        if (best == null) return r;
        const bestRank = ROLES_FOR_VISIBILITY_SETTING.indexOf(best);
        return rank < bestRank ? r : best;
    }, null);
}